import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pacoteCampanhaCountLabel'
})
export class PacoteCampanhaCountLabelPipe implements PipeTransform {
    transform(count: number): string {
        if (count == null || count === undefined) {
            return '';
        }

        return count == 1 ? 'Pacote' : 'Pacotes';
    }
}
